import React from 'react';
import SignalCellular1BarOutlined from "@material-ui/icons/SignalCellular1BarOutlined";
import SignalCellular2BarOutlined from "@material-ui/icons/SignalCellular2BarOutlined";
import SignalCellular3BarOutlined from "@material-ui/icons/SignalCellular3BarOutlined";
import SignalCellular4BarOutlined from "@material-ui/icons/SignalCellular4BarOutlined";
import Tooltip from "@material-ui/core/Tooltip";

interface ISignalStrengthIconProps {
    show: boolean;
    color: string;
    signalStrength: number;
}

export const SignalStrengthIcon = (props: ISignalStrengthIconProps) => {
    const { show, color, signalStrength } = props;
    if (!show) {
        return null;
    }
    const COLOR_GREEN = '#31b800';
    const COLOR_BLUE = '#00acc1';
    const COLOR_YELLOW = '#ffe11c';
    const COLOR_RED = '#ff0000';
    if (signalStrength == null) {
    return (
        <Tooltip title={`Signal strength (--)`}>
            <div style={{color: COLOR_BLUE}}>
                <SignalCellular2BarOutlined/>
            </div>
        </Tooltip>
    );
    } else if (signalStrength < 30) {
        return (
            <Tooltip title={`Signal strength (${signalStrength})`}>
                <div style={{color: COLOR_RED}}>
                    <SignalCellular1BarOutlined/>
                </div>
            </Tooltip>
        );        
    } else if (signalStrength <= 60) {
        return (
            <Tooltip title={`Signal strength (${signalStrength})`}>
                <div style={{color: COLOR_YELLOW}}>
                    <SignalCellular3BarOutlined/>
                </div>
            </Tooltip>
        );
    } else {
        return (
            <Tooltip title={`Signal strength (${signalStrength})`}>
                <div style={{color: COLOR_GREEN}}>
                    <SignalCellular4BarOutlined/>
                </div>
            </Tooltip>
        );
    }
};

export default SignalStrengthIcon;
